import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchReport,
  fetchReviewsByCompany,
  saveReview,
  onLogin,
  startChat,
} from '~actions'; // eslint-disable-line

// Components
import ReviewsContainer from './ReviewsContainer';

const propTypes = {
  match: PropTypes.object, // Injected by React Router
  report: PropTypes.object.isRequired,
  fetchReport: PropTypes.func.isRequired,
  fetchReviewsByCompany: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
};

class CompanyReviews extends PureComponent {
  componentWillMount() {
    const { match, report } = this.props;
    const { country, identifier } = match.params;
    if (report.identifier !== identifier) {
      this.props.fetchReport({ country, identifier });
    }

    this.props.fetchReviewsByCompany({ country, identifier });
  }

  _onLogin = authData => {
    const data = authData;
    const { country, identifier } = this.props.match.params;
    if (!country || !identifier) {
      this.props.onLogin(data);
      return;
    }

    data.country = country;
    data.identifier = identifier;
    this.props.onLogin(data);
  };

  render() {
    return (
      <ReviewsContainer {...this.props} onLogin={this._onLogin} />
    );
  }
}

CompanyReviews.propTypes = propTypes;

// This makes state objects available to the component via props!
function mapStateToProps(state) {
  return {
    report: state.report,
    reviews: state.companyReviews.reviews,
    session: state.session,
    locale: state.locale,
    review: state.review,
  };
}

// This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchReport,
      fetchReviewsByCompany,
      saveReview,
      onLogin,
      startChat,
    },
    dispatch,
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(CompanyReviews);
